interface CourseStickyCtaProps {
  priceLabel: string;
  onRegister: () => void;
  ctaLabel?: string;
  priceCaption?: string;
}

const CourseStickyCta = ({
  priceLabel,
  onRegister,
  ctaLabel = 'Đăng ký ngay',
  priceCaption = 'Học phí',
}: CourseStickyCtaProps) => {
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 lg:hidden border-t border-m2-outline-variant bg-m2-surface-container/95 backdrop-blur px-4 py-3 safe-area-pb">
      <div className="flex items-center justify-between gap-3 max-w-lg mx-auto">
        <div>
          {priceCaption ? (
            <p className="text-xs text-m2-on-surface-variant">{priceCaption}</p>
          ) : null}
          <p className="text-lg font-bold text-m2-on-surface">{priceLabel}</p>
        </div>
        <button
          type="button"
          onClick={onRegister}
          className="btn-primary px-5 py-3 text-sm font-semibold whitespace-nowrap"
        >
          {ctaLabel}
        </button>
      </div>
    </div>
  );
};

export default CourseStickyCta;
